// Small client for the Netlify Functions in /netlify/functions (likes + guestbook).
// Every call fails softly: if the API is unreachable (e.g. plain `yarn start` locally),
// the gallery keeps working and the like counts / guestbook simply show as unavailable.

// A random id this browser keeps, so the server can remember its likes even when the IP changes.
const visitorId = () => {
  try {
    let id = localStorage.getItem('visitor-id');
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem('visitor-id', id);
    }
    return id;
  } catch (e) {
    return ''; // storage blocked: the server falls back to the IP
  }
};

const request = async (path, options = {}) => {
  const id = visitorId();
  const res = await fetch(path, {
    headers: { 'content-type': 'application/json', ...(id && { 'x-visitor-id': id }) },
    ...options,
  });
  // When the functions aren't deployed, /api/* falls through to the site's index.html (200).
  // That is not the API, so treat it as unavailable instead of as an empty answer.
  if (!(res.headers.get('content-type') || '').includes('application/json')) {
    throw Object.assign(new Error('API unavailable'), { status: res.status });
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.error || `Request failed (${res.status})`), { status: res.status });
  return data;
};

export const fetchLikes = () => request('/api/likes');
export const setLike = (id, liked) =>
  request(`/api/likes?id=${encodeURIComponent(id)}`, { method: liked ? 'POST' : 'DELETE' });

export const fetchGuestbook = () => request('/api/guestbook');
export const postGuestbook = (entry) => request('/api/guestbook', { method: 'POST', body: JSON.stringify(entry) });
